import Vue from 'vue';

export default {
    upload(file, config) {
        return Vue.axios.post('/v1.0/files', file, config);
    }
};
